export { IconSvg, IconSvgSizes} from './icon-svg';
export type { IconSvgProps } from './icon-svg';
export { IconSvgInterface } from './icon-svg.interface';
